import { render, staticRenderFns } from "./TimeRangeRepetition.vue?vue&type=template&id=10d487c4&scoped=true"
import script from "./TimeRangeRepetition.vue?vue&type=script&lang=js"
export * from "./TimeRangeRepetition.vue?vue&type=script&lang=js"
import style0 from "./TimeRangeRepetition.vue?vue&type=style&index=0&id=10d487c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d487c4",
  null
  
)

export default component.exports